<template>
  <div class="JadwalEdit">
    <label for="input" class="f-14 f-Overpass f-c-midgrey p-t-16 require">{{
      label
    }}</label>
    <div class="form-control">
      <p class="f-bold f-Overpass f-16 f-c-black">
        {{ formatDate }}
      </p>
    </div>

    <template v-if="status == '50_selesai'">
      <div class="p-t-8">
        <button class="btn width-100 f-c-blue f-bold">
          <a class href="#" target="_blank" :class="'text-decoration-none'">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6977 3.00115C11.5424 2.14055 12.6832 1.65599 13.8767 1.66693C15.0702 1.67787 16.2024 2.18321 17.0322 3.05864C17.8607 3.93263 18.3235 5.10603 18.3335 6.32402C18.3435 7.542 17.9002 8.72327 17.0867 9.61182L17.0769 9.62239L14.8791 11.9409C14.8791 11.941 14.8791 11.941 14.879 11.941C14.4256 12.4195 13.877 12.7925 13.269 13.0318C12.6608 13.2712 12.0092 13.3703 11.3591 13.3212C10.7091 13.2721 10.0788 13.0761 9.51117 12.7489C8.94367 12.4219 8.45309 11.9719 8.07053 11.4324C7.80433 11.0569 7.89289 10.5368 8.26833 10.2706C8.64377 10.0044 9.16392 10.0929 9.43012 10.4684C9.6768 10.8163 9.98903 11.1007 10.3434 11.305C10.6977 11.5091 11.0868 11.6292 11.4847 11.6592C11.8825 11.6893 12.2826 11.6289 12.6587 11.4809C13.0349 11.3329 13.3801 11.0998 13.6693 10.7946L13.6694 10.7944L15.862 8.48138C16.3802 7.91276 16.6735 7.14387 16.6669 6.33775C16.6602 5.52929 16.3525 4.76421 15.8226 4.20523C15.2941 3.64768 14.5888 3.34019 13.8615 3.33353C13.1359 3.32687 12.4278 3.61986 11.8912 4.16454L10.6355 5.48153C10.3179 5.81463 9.79045 5.8272 9.45735 5.50961C9.12425 5.19202 9.11168 4.66453 9.42927 4.33143L10.6894 3.00981L10.6977 3.00115ZM6.73166 6.96834C7.33989 6.72898 7.99149 6.62988 8.64153 6.67899C9.29152 6.7281 9.9218 6.92402 10.4895 7.25122C11.057 7.57831 11.5476 8.02823 11.9301 8.56778C12.1963 8.94322 12.1078 9.46338 11.7323 9.72958C11.3569 9.99578 10.8367 9.90722 10.5705 9.53178C10.3238 9.18387 10.0116 8.89948 9.65721 8.69521C9.30298 8.49104 8.91381 8.37098 8.51596 8.34092C8.11816 8.31086 7.71802 8.37125 7.34198 8.51924C6.96577 8.66729 6.62058 8.90035 6.33133 9.20561L6.33123 9.20572L4.13867 11.5188C3.62048 12.0874 3.32713 12.8563 3.33377 13.6624C3.34043 14.4709 3.64814 15.236 4.17801 15.7949C4.70651 16.3525 5.41182 16.66 6.1392 16.6666C6.86437 16.6733 7.57213 16.3806 8.10866 15.8364L9.35613 14.5204C9.67275 14.1864 10.2002 14.1723 10.5342 14.4889C10.8682 14.8055 10.8823 15.333 10.5657 15.667L9.31296 16.9886L9.30291 16.999C8.45829 17.8596 7.31749 18.3442 6.12392 18.3332C4.93041 18.3223 3.79824 17.817 2.96841 16.9415C2.13996 16.0675 1.67719 14.8941 1.66716 13.6761C1.65713 12.4582 2.10046 11.2769 2.91394 10.3883L2.92379 10.3778L5.12153 8.05925C5.12156 8.05921 5.12159 8.05918 5.12163 8.05914C5.57506 7.58064 6.12363 7.20762 6.73166 6.96834Z"
                fill="#0052F5"
              />
            </svg>
            Link Rekaman Meeting
          </a>
        </button>
      </div>
    </template>

    <template
      v-if="status == '20_terjadwalkan' || status == '30_dijadwalkan_ulang'"
    >
      <div class="d-flex-between-center p-t-8">
        <button
          class="btn width-100 link_zoom"
          :disabled="link_zoom != '' ? false : true"
          v-if="link_zoom != ''"
        >
          <a
            :href="link_zoom"
            class="text-decoration-none f-c-green f-16 f-bold"
            target="__blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.1973 3.00108C12.0419 2.14048 13.1827 1.65591 14.3762 1.66685C15.5698 1.67779 16.7019 2.18313 17.5318 3.05857C18.3602 3.93255 18.823 5.10596 18.833 6.32395C18.843 7.54192 18.3997 8.7232 17.5862 9.61175L17.5764 9.62232L15.3786 11.9408C15.3786 11.9409 15.3786 11.9409 15.3785 11.9409C14.9251 12.4194 14.3765 12.7925 13.7685 13.0317C13.1603 13.2711 12.5087 13.3702 11.8586 13.3211C11.2086 13.272 10.5784 13.0761 10.0107 12.7489C9.44318 12.4218 8.9526 11.9719 8.57004 11.4323C8.30384 11.0569 8.3924 10.5367 8.76784 10.2705C9.14328 10.0043 9.66343 10.0929 9.92963 10.4683C10.1763 10.8162 10.4885 11.1006 10.843 11.3049C11.1972 11.5091 11.5864 11.6291 11.9842 11.6592C12.382 11.6892 12.7821 11.6288 13.1582 11.4808C13.5344 11.3328 13.8796 11.0997 14.1688 10.7945L14.1689 10.7944L16.3615 8.48131C16.8797 7.91268 17.173 7.1438 17.1664 6.33768C17.1597 5.52921 16.852 4.76414 16.3222 4.20515C15.7937 3.64761 15.0883 3.34012 14.361 3.33345C13.6354 3.3268 12.9273 3.61979 12.3907 4.16446L11.135 5.48145C10.8174 5.81455 10.29 5.82712 9.95686 5.50953C9.62376 5.19194 9.61119 4.66445 9.92878 4.33135L11.1889 3.00973L11.1973 3.00108ZM7.23117 6.96827C7.8394 6.72891 8.491 6.6298 9.14104 6.67891C9.79103 6.72802 10.4213 6.92395 10.989 7.25114C11.5565 7.57824 12.0471 8.02816 12.4296 8.56771C12.6958 8.94315 12.6073 9.4633 12.2318 9.7295C11.8564 9.9957 11.3362 9.90715 11.07 9.53171C10.8234 9.1838 10.5111 8.8994 10.1567 8.69513C9.80249 8.49096 9.41332 8.3709 9.01547 8.34084C8.61767 8.31079 8.21753 8.37118 7.84149 8.51916C7.46528 8.66721 7.12009 8.90028 6.83084 9.20553L6.83074 9.20564L4.63819 11.5187C4.11999 12.0873 3.82664 12.8562 3.83328 13.6623C3.83994 14.4708 4.14765 15.2359 4.67752 15.7949C5.20602 16.3524 5.91134 16.6599 6.63871 16.6666C7.36389 16.6732 8.07164 16.3805 8.60817 15.8363L9.85564 14.5203C10.1723 14.1863 10.6997 14.1722 11.0337 14.4888C11.3678 14.8054 11.3819 15.3329 11.0652 15.6669L9.81247 16.9885L9.80242 16.9989C8.9578 17.8595 7.817 18.3441 6.62343 18.3332C5.42992 18.3222 4.29775 17.8169 3.46792 16.9414C2.63947 16.0675 2.1767 14.8941 2.16667 13.6761C2.15664 12.4581 2.59998 11.2768 3.41345 10.3883L3.4233 10.3777L5.62104 8.05917C5.62107 8.05914 5.62111 8.0591 5.62114 8.05906C6.07457 7.58057 6.62315 7.20754 7.23117 6.96827Z"
                fill="#40964C"
              />
            </svg>
            Link Zoom
          </a>
        </button>

        <button
          class="btn width-100 rescedule"
          v-if="status == '20_terjadwalkan' && idjenis != 'free_online'"
        >
          <a
            class="f-c-blue f-16 f-bold text-decoration-none"
            @click="
              popUpRescedule(
                label,
                id_Training_Detail,
                jadwal_start,
                jadwal_change,
                range_date
              )
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.68757 3.52946C8.12787 2.69739 9.80178 2.36195 11.4515 2.57481C13.1012 2.78768 14.6351 3.53703 15.817 4.70746C16.9989 5.87788 17.7632 7.40443 17.9922 9.05196C18.0555 9.50782 17.7373 9.92872 17.2815 9.99207C16.8256 10.0554 16.4047 9.73723 16.3414 9.28137C16.1627 7.99594 15.5664 6.80489 14.6443 5.89171C13.7221 4.97852 12.5253 4.39386 11.2382 4.22778C9.95107 4.0617 8.64504 4.32341 7.5213 4.97261C6.72966 5.42995 5.94492 6.01462 5.36152 6.66667H7.16677C7.62701 6.66667 8.0001 7.03976 8.0001 7.5C8.0001 7.96024 7.62701 8.33333 7.16677 8.33333H3.83344C3.3732 8.33333 3.0001 7.96024 3.0001 7.5V4.16667C3.0001 3.70643 3.3732 3.33333 3.83344 3.33333C4.29367 3.33333 4.66677 3.70643 4.66677 4.16667V5.00017C5.31334 4.40116 6.03569 3.90606 6.68757 3.52946ZM3.71873 10.0079C4.17458 9.94458 4.59549 10.2628 4.65884 10.7186C4.83748 12.0041 5.4338 13.1951 6.35594 14.1083C7.27809 15.0215 8.4749 15.6061 9.76202 15.7722C11.0491 15.9383 12.3552 15.6766 13.4789 15.0274C14.2705 14.57 15.0553 13.9854 15.6387 13.3333H13.8334C13.3732 13.3333 13.0001 12.9602 13.0001 12.5C13.0001 12.0398 13.3732 11.6667 13.8334 11.6667H17.1668C17.627 11.6667 18.0001 12.0398 18.0001 12.5V15.8333C18.0001 16.2936 17.627 16.6667 17.1668 16.6667C16.7065 16.6667 16.3334 16.2936 16.3334 15.8333V14.9998C15.6869 15.5988 14.9645 16.0939 14.3126 16.4705C12.8723 17.3026 11.1984 17.6381 9.54873 17.4252C7.89904 17.2123 6.3651 16.463 5.1832 15.2925C4.00129 14.1221 3.23699 12.5956 3.00803 10.948C2.94468 10.4922 3.26287 10.0713 3.71873 10.0079Z"
                fill="#206CFE"
              />
            </svg>
            Reschedule
          </a>
        </button>
      </div>
    </template>

    <div class="modal fade" id="modal" role="dialog">
      <div class="modal-dialog modal-lg bani-modal">
        <div class="modal-content w-limit">
          <div class="modal-header">
            <div class="nav-btn kiri"></div>
            <h5 class="navbar-title text-center">Reschedule Training</h5>
            <div class="nav-btn kanan tutup">
              <img src="@/assets/img/x2.svg" data-dismiss="modal" alt="" />
            </div>
          </div>
          <div class="modal-body p-t-16">
            <p class="f-14 f-Overpass f-c-black remove-margin">
              Apakah anda yakin ingin melakukan reschedule?
            </p>
            <p class="p-t-12 f-14 f-Overpass f-c-black">
              Status yang sudah
              <span class="f-bold">Dijadwalkan</span> akan diganti menjadi
              <span class="f-bold">Menunggu Konfirmasi CS</span> dan akan diubah
              sesuai dengan jadwal yang bisa di handle oleh Customer Service
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary btn-long"
              data-dismiss="modal"
              @click="changeSchedule(id_training, idjenis)"
            >
              Ya, Lanjutkan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// let months = [
//   "Januari",
//   "Februari",
//   "Maret",
//   "April",
//   "Mei",
//   "Juni",
//   "Juli",
//   "Agustus",
//   "September",
//   "Oktober",
//   "November",
//   "Desember",
// ];

import { mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "JadwalEdit",
  props: {
    label: "",
    jadwal_start: "",
    jadwal_end: "",
    status: "",
    idjenis: "",
    id_Training_Detail: "",
    id_training: "",
    range_date: "",
    link_zoom: "",
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters(moduleName, {
      dataRescedule: "dataRescedule",
    }),

    formatDate() {
      let format_mulai = this.$moment(this.jadwal_start).format(
        "DD MMMM YYYY HH:mm"
      );
      let format_selesai = this.$moment(this.jadwal_end).format("HH:mm");

      return `${format_mulai} - ${format_selesai}`;
      // const date_1 = this.date_s;
      // const date_2 = this.date_e;
      // const tanggal = date_1.getDate();
      // const month = date_1.getMonth();
      // const month_Ina = this.bulan[month];
      // const year = date_1.getFullYear();
      // const time_start_hours = String(date_1.getHours()).padStart(2, "0");
      // const time_start_minutes = String(date_1.getMinutes()).padStart(2, "0");
      // const time_end_hours = String(date_2.getHours()).padStart(2, "0");
      // const time_end_minutes = String(date_2.getMinutes()).padStart(2, "0");

      // return `${tanggal} ${month_Ina} ${year} ${time_start_hours}:${time_start_minutes} - ${time_end_hours}:${time_end_minutes}`;
    },

    textJadwalKe() {
      if (this.label == "Pertemuan ke 1") {
        return "Jadwal Ke 1";
      }
      if (this.label == "Pertemuan ke 2") {
        return "Jadwal Ke 2";
      }
    },
  },

  methods: {
    popUpRescedule(label, id_Training_Detail, jadwal_start, range_date) {
      this.dataRescedule.jadwal_ke = this.textJadwalKe;
      this.dataRescedule.id_detail_training = this.id_Training_Detail;
      this.dataRescedule.jadwal_change =
        this.$moment(jadwal_start).format("YYYY-MM-DD");
      if (this.range_date != "") {
        this.dataRescedule.jadwal_range = this.$moment(this.range_date).format(
          "YYYY-MM-DD"
        );
      }

      $("#modal").modal("show");
    },

    changeSchedule(id_training, id_jenis) {
      this.$router.push({
        name: "resceduleJadwal",
        params: { idtraining: id_training, idjenis: id_jenis },
      });
    },
  },
};
</script>
